import { CloudDownload } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useEffect, useState } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useParams } from "react-router-dom";

export function AttendanceRecordsDownloadPage() {
  const { formatMessage: t } = useIntl();
  const { attendanceRecordService } = useGlobalContext();
  const [downloadUrl, setdownloadUrl] = useState<string>("");
  const { fileId } = useParams<{ fileId: string }>();

  useTitle(t({ id: "downloadAttendanceRecords" }));

  useEffect(() => {
    if (fileId) {
      attendanceRecordService.getDownloadUrl(fileId).then(setdownloadUrl);
    }
  }, [attendanceRecordService, fileId]);

  if (!downloadUrl) {
    return <></>;
  }

  return (
    <Box mb={4}>
      <Button
        type="submit"
        color="primary"
        variant="outlined"
        href={downloadUrl}
        target="_blank"
        startIcon={<CloudDownload />}
        style={{ height: "100%" }}
      >
        <T id="downloadAttendanceRecords" />
      </Button>
    </Box>
  );
}
